import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

class Stage7 extends Component {
	render() {
		
		if(!this.props.terms) return null;
		
		return (
			<div>

			<RichText content={this.props.terms.stage_7} />
			</div>
		);
	}
}

export default withRouter(withPrismic(withFirebase(Stage7)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/Stage7.js